module.exports = __webpack_public_path__ + "img/lake-2.7ba159f1.jpg";